import { Form, Input, InputNumber, Switch } from "antd";
import { useEffect } from "react";
import HealthConsultationImageUploader from "./HealthConsultationImageUploader";

export default function HealthConsultationConfigForm({ form, item }: any) {
    useEffect(() => {
        form.resetFields();
        form.setFieldsValue({
            channel: "default",
            enable: true,
            silence: 168,
            ...item,
        });
    }, [form, item]);

    return (
        <Form
            form={form}
            name="healthConsultationConfigForm"
            labelCol={{ span: 7 }}
            wrapperCol={{ span: 15 }}
            autoComplete="off"
        >
            <Form.Item
                label="渠道"
                name="channel"
                rules={[{ required: true, whitespace: true, message: "请输入渠道标识" }]}
            >
                <Input placeholder="例如：default" maxLength={64} />
            </Form.Item>
            <Form.Item label="是否开启" name="enable" valuePropName="checked">
                <Switch checkedChildren="开启" unCheckedChildren="关闭" />
            </Form.Item>
            <Form.Item
                label="企业获客助手链接"
                name="dialogWorkUrl"
            >
                <Input placeholder="请输入企业获客助手链接" />
            </Form.Item>
            <Form.Item
                label="微信号"
                name="wechatId"
                rules={[{ required: true, whitespace: true, message: "请输入微信号" }]}
            >
                <Input placeholder="请输入微信号" maxLength={128} />
            </Form.Item>
            <Form.Item
                label="浮窗关闭沉默时长"
                name="silence"
                rules={[{ required: true, message: "请输入浮窗关闭沉默时长" }]}
            >
                <InputNumber
                    min={0}
                    precision={0}
                    style={{ width: "100%" }}
                    addonAfter="小时"
                    placeholder="请输入时长"
                />
            </Form.Item>
            <Form.Item
                label="二维码 URL"
                name="qrCode"
            >
                <Input placeholder="请输入二维码图片 URL，或在下方上传" />
            </Form.Item>
            <HealthConsultationImageUploader
                form={form}
                name="qrCode"
                label="二维码图片"
            />
            <Form.Item
                label="浮窗 URL"
                name="diagnoseEntryUrl"
                rules={[{ required: true, whitespace: true, message: "请输入浮窗图片 URL" }]}
            >
                <Input placeholder="请输入浮窗图片 URL，或在下方上传" />
            </Form.Item>
            <HealthConsultationImageUploader
                form={form}
                name="diagnoseEntryUrl"
                label="浮窗图片"
            />
            <Form.Item
                label="弹窗背景 URL"
                name="dialogTopBgUrl"
                rules={[{ required: true, whitespace: true, message: "请输入弹窗背景图片 URL" }]}
            >
                <Input placeholder="请输入弹窗背景图片 URL，或在下方上传" />
            </Form.Item>
            <HealthConsultationImageUploader
                form={form}
                name="dialogTopBgUrl"
                label="弹窗背景图片"
            />
        </Form>
    );
}
